/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ClientSDK } from "../lib/sdks.js";
import { Access } from "./access.js";
import { AdminAssets } from "./adminassets.js";
import { AdminChatAnalysis } from "./adminchatanalysis.js";
import { AdminExternalCredentials } from "./adminexternalcredentials.js";
import { AdminOpenRouterKeys } from "./adminopenrouterkeys.js";
import { AdminRemoteSessions } from "./adminremotesessions.js";
import { Agent } from "./agent.js";
import { Agents } from "./agents.js";
import { AiIntegrations } from "./aiintegrations.js";
import { Analytics } from "./analytics.js";
import { Assets } from "./assets.js";
import { AssistantMemories } from "./assistantmemories.js";
import { Assistants } from "./assistants.js";
import { Auditlogs } from "./auditlogs.js";
import { Auth } from "./auth.js";
import { BusinessMemories } from "./businessmemories.js";
import { Chat } from "./chat.js";
import { ChatSessions } from "./chatsessions.js";
import { CliAuth } from "./cliauth.js";
import { Dashboards } from "./dashboards.js";
import { DataExports } from "./dataexports.js";
import { Deployments } from "./deployments.js";
import { DeviceIntegrations } from "./deviceintegrations.js";
import { Domains } from "./domains.js";
import { Environments } from "./environments.js";
import { External } from "./external.js";
import { ExternalCredentials } from "./externalcredentials.js";
import { ExternalKeys } from "./externalkeys.js";
import { Features } from "./features.js";
import { Hooks } from "./hooks.js";
import { HooksServerNames } from "./hooksservernames.js";
import { Identity } from "./identity.js";
import { IdentityProviderConnections } from "./identityproviderconnections.js";
import { Instances } from "./instances.js";
import { Integrations } from "./integrations.js";
import { InternalSessionIssuers } from "./internalsessionissuers.js";
import { JsonWebKeySets } from "./jsonwebkeysets.js";
import { Keys } from "./keys.js";
import { Killswitches } from "./killswitches.js";
import { Launcher } from "./launcher.js";
import { Litellm } from "./litellm.js";
import { McpApproval } from "./mcpapproval.js";
import { McpEndpoints } from "./mcpendpoints.js";
import { McpMetadata } from "./mcpmetadata.js";
import { McpRegistries } from "./mcpregistries.js";
import { McpServers } from "./mcpservers.js";
import { MetaMcp } from "./metamcp.js";
import { ModelKeys } from "./modelkeys.js";
import { NetworkIngress } from "./networkingress.js";
import { OktaResourceConnections } from "./oktaresourceconnections.js";
import { OktaServerSuggestions } from "./oktaserversuggestions.js";
import { OrganizationAssets } from "./organizationassets.js";
import { OrganizationRemoteSessionClients } from "./organizationremotesessionclients.js";
import { OrganizationRemoteSessionIssuers } from "./organizationremotesessionissuers.js";
import { OrganizationRemoteSessions } from "./organizationremotesessions.js";
import { Organizations } from "./organizations.js";
import { OrganizationUserSessionIssuers } from "./organizationusersessionissuers.js";
import { Otel } from "./otel.js";
import { Packages } from "./packages.js";
import { PlatformKillswitches } from "./platformkillswitches.js";
import { PlatformMcp } from "./platformmcp.js";
import { Plugins } from "./plugins.js";
import { Projects } from "./projects.js";
import { RegistryDiscovery } from "./registrydiscovery.js";
import { RemoteMcp } from "./remotemcp.js";
import { RemoteSessionClients } from "./remotesessionclients.js";
import { RemoteSessionIssuers } from "./remotesessionissuers.js";
import { RemoteSessions } from "./remotesessions.js";
import { Resources } from "./resources.js";
import { Risk } from "./risk.js";
import { Sigint } from "./sigint.js";
import { SkillEfficacy } from "./skillefficacy.js";
import { Skills } from "./skills.js";
import { SlackDirectoryConnections } from "./slackdirectoryconnections.js";
import { SpendRules } from "./spendrules.js";
import { Telemetry } from "./telemetry.js";
import { Templates } from "./templates.js";
import { TokenExchange } from "./tokenexchange.js";
import { Tools } from "./tools.js";
import { Toolsets } from "./toolsets.js";
import { Triggers } from "./triggers.js";
import { TunneledMcp } from "./tunneledmcp.js";
import { UnproxiedMcp } from "./unproxiedmcp.js";
import { Usage } from "./usage.js";
import { UserSessionClients } from "./usersessionclients.js";
import { UserSessionConsents } from "./usersessionconsents.js";
import { UserSessionIssuers } from "./usersessionissuers.js";
import { UserSessionIssuersCimdClients } from "./usersessionissuerscimdclients.js";
import { UserSessions } from "./usersessions.js";
import { Variations } from "./variations.js";
import { Widgets } from "./widgets.js";
import { WorkloadIdentities } from "./workloadidentities.js";

export class Gram extends ClientSDK {
  private _otel?: Otel;
  get otel(): Otel {
    return (this._otel ??= new Otel(this._options));
  }

  private _access?: Access;
  get access(): Access {
    return (this._access ??= new Access(this._options));
  }

  private _adminAssets?: AdminAssets;
  get adminAssets(): AdminAssets {
    return (this._adminAssets ??= new AdminAssets(this._options));
  }

  private _adminChatAnalysis?: AdminChatAnalysis;
  get adminChatAnalysis(): AdminChatAnalysis {
    return (this._adminChatAnalysis ??= new AdminChatAnalysis(this._options));
  }

  private _adminExternalCredentials?: AdminExternalCredentials;
  get adminExternalCredentials(): AdminExternalCredentials {
    return (this._adminExternalCredentials ??= new AdminExternalCredentials(
      this._options,
    ));
  }

  private _adminOpenRouterKeys?: AdminOpenRouterKeys;
  get adminOpenRouterKeys(): AdminOpenRouterKeys {
    return (this._adminOpenRouterKeys ??= new AdminOpenRouterKeys(
      this._options,
    ));
  }

  private _adminRemoteSessions?: AdminRemoteSessions;
  get adminRemoteSessions(): AdminRemoteSessions {
    return (this._adminRemoteSessions ??= new AdminRemoteSessions(
      this._options,
    ));
  }

  private _agent?: Agent;
  get agent(): Agent {
    return (this._agent ??= new Agent(this._options));
  }

  private _agents?: Agents;
  get agents(): Agents {
    return (this._agents ??= new Agents(this._options));
  }

  private _aiIntegrations?: AiIntegrations;
  get aiIntegrations(): AiIntegrations {
    return (this._aiIntegrations ??= new AiIntegrations(this._options));
  }

  private _analytics?: Analytics;
  get analytics(): Analytics {
    return (this._analytics ??= new Analytics(this._options));
  }

  private _assets?: Assets;
  get assets(): Assets {
    return (this._assets ??= new Assets(this._options));
  }

  private _assistantMemories?: AssistantMemories;
  get assistantMemories(): AssistantMemories {
    return (this._assistantMemories ??= new AssistantMemories(this._options));
  }

  private _assistants?: Assistants;
  get assistants(): Assistants {
    return (this._assistants ??= new Assistants(this._options));
  }

  private _auditlogs?: Auditlogs;
  get auditlogs(): Auditlogs {
    return (this._auditlogs ??= new Auditlogs(this._options));
  }

  private _auth?: Auth;
  get auth(): Auth {
    return (this._auth ??= new Auth(this._options));
  }

  private _businessMemories?: BusinessMemories;
  get businessMemories(): BusinessMemories {
    return (this._businessMemories ??= new BusinessMemories(this._options));
  }

  private _chat?: Chat;
  get chat(): Chat {
    return (this._chat ??= new Chat(this._options));
  }

  private _chatSessions?: ChatSessions;
  get chatSessions(): ChatSessions {
    return (this._chatSessions ??= new ChatSessions(this._options));
  }

  private _cliAuth?: CliAuth;
  get cliAuth(): CliAuth {
    return (this._cliAuth ??= new CliAuth(this._options));
  }

  private _dashboards?: Dashboards;
  get dashboards(): Dashboards {
    return (this._dashboards ??= new Dashboards(this._options));
  }

  private _dataExports?: DataExports;
  get dataExports(): DataExports {
    return (this._dataExports ??= new DataExports(this._options));
  }

  private _deployments?: Deployments;
  get deployments(): Deployments {
    return (this._deployments ??= new Deployments(this._options));
  }

  private _deviceIntegrations?: DeviceIntegrations;
  get deviceIntegrations(): DeviceIntegrations {
    return (this._deviceIntegrations ??= new DeviceIntegrations(this._options));
  }

  private _domains?: Domains;
  get domains(): Domains {
    return (this._domains ??= new Domains(this._options));
  }

  private _environments?: Environments;
  get environments(): Environments {
    return (this._environments ??= new Environments(this._options));
  }

  private _external?: External;
  get external(): External {
    return (this._external ??= new External(this._options));
  }

  private _externalCredentials?: ExternalCredentials;
  get externalCredentials(): ExternalCredentials {
    return (this._externalCredentials ??= new ExternalCredentials(
      this._options,
    ));
  }

  private _externalKeys?: ExternalKeys;
  get externalKeys(): ExternalKeys {
    return (this._externalKeys ??= new ExternalKeys(this._options));
  }

  private _hooks?: Hooks;
  get hooks(): Hooks {
    return (this._hooks ??= new Hooks(this._options));
  }

  private _hooksServerNames?: HooksServerNames;
  get hooksServerNames(): HooksServerNames {
    return (this._hooksServerNames ??= new HooksServerNames(this._options));
  }

  private _identity?: Identity;
  get identity(): Identity {
    return (this._identity ??= new Identity(this._options));
  }

  private _identityProviderConnections?: IdentityProviderConnections;
  get identityProviderConnections(): IdentityProviderConnections {
    return (this._identityProviderConnections ??=
      new IdentityProviderConnections(this._options));
  }

  private _instances?: Instances;
  get instances(): Instances {
    return (this._instances ??= new Instances(this._options));
  }

  private _integrations?: Integrations;
  get integrations(): Integrations {
    return (this._integrations ??= new Integrations(this._options));
  }

  private _internalSessionIssuers?: InternalSessionIssuers;
  get internalSessionIssuers(): InternalSessionIssuers {
    return (this._internalSessionIssuers ??= new InternalSessionIssuers(
      this._options,
    ));
  }

  private _jsonWebKeySets?: JsonWebKeySets;
  get jsonWebKeySets(): JsonWebKeySets {
    return (this._jsonWebKeySets ??= new JsonWebKeySets(this._options));
  }

  private _keys?: Keys;
  get keys(): Keys {
    return (this._keys ??= new Keys(this._options));
  }

  private _killswitches?: Killswitches;
  get killswitches(): Killswitches {
    return (this._killswitches ??= new Killswitches(this._options));
  }

  private _launcher?: Launcher;
  get launcher(): Launcher {
    return (this._launcher ??= new Launcher(this._options));
  }

  private _litellm?: Litellm;
  get litellm(): Litellm {
    return (this._litellm ??= new Litellm(this._options));
  }

  private _mcpApproval?: McpApproval;
  get mcpApproval(): McpApproval {
    return (this._mcpApproval ??= new McpApproval(this._options));
  }

  private _mcpEndpoints?: McpEndpoints;
  get mcpEndpoints(): McpEndpoints {
    return (this._mcpEndpoints ??= new McpEndpoints(this._options));
  }

  private _mcpMetadata?: McpMetadata;
  get mcpMetadata(): McpMetadata {
    return (this._mcpMetadata ??= new McpMetadata(this._options));
  }

  private _mcpRegistries?: McpRegistries;
  get mcpRegistries(): McpRegistries {
    return (this._mcpRegistries ??= new McpRegistries(this._options));
  }

  private _mcpServers?: McpServers;
  get mcpServers(): McpServers {
    return (this._mcpServers ??= new McpServers(this._options));
  }

  private _metaMcp?: MetaMcp;
  get metaMcp(): MetaMcp {
    return (this._metaMcp ??= new MetaMcp(this._options));
  }

  private _modelKeys?: ModelKeys;
  get modelKeys(): ModelKeys {
    return (this._modelKeys ??= new ModelKeys(this._options));
  }

  private _networkIngress?: NetworkIngress;
  get networkIngress(): NetworkIngress {
    return (this._networkIngress ??= new NetworkIngress(this._options));
  }

  private _oktaResourceConnections?: OktaResourceConnections;
  get oktaResourceConnections(): OktaResourceConnections {
    return (this._oktaResourceConnections ??= new OktaResourceConnections(
      this._options,
    ));
  }

  private _oktaServerSuggestions?: OktaServerSuggestions;
  get oktaServerSuggestions(): OktaServerSuggestions {
    return (this._oktaServerSuggestions ??= new OktaServerSuggestions(
      this._options,
    ));
  }

  private _organizationAssets?: OrganizationAssets;
  get organizationAssets(): OrganizationAssets {
    return (this._organizationAssets ??= new OrganizationAssets(this._options));
  }

  private _organizationRemoteSessionClients?: OrganizationRemoteSessionClients;
  get organizationRemoteSessionClients(): OrganizationRemoteSessionClients {
    return (this._organizationRemoteSessionClients ??=
      new OrganizationRemoteSessionClients(this._options));
  }

  private _organizationRemoteSessionIssuers?: OrganizationRemoteSessionIssuers;
  get organizationRemoteSessionIssuers(): OrganizationRemoteSessionIssuers {
    return (this._organizationRemoteSessionIssuers ??=
      new OrganizationRemoteSessionIssuers(this._options));
  }

  private _organizationRemoteSessions?: OrganizationRemoteSessions;
  get organizationRemoteSessions(): OrganizationRemoteSessions {
    return (this._organizationRemoteSessions ??= new OrganizationRemoteSessions(
      this._options,
    ));
  }

  private _organizationUserSessionIssuers?: OrganizationUserSessionIssuers;
  get organizationUserSessionIssuers(): OrganizationUserSessionIssuers {
    return (this._organizationUserSessionIssuers ??=
      new OrganizationUserSessionIssuers(this._options));
  }

  private _organizations?: Organizations;
  get organizations(): Organizations {
    return (this._organizations ??= new Organizations(this._options));
  }

  private _packages?: Packages;
  get packages(): Packages {
    return (this._packages ??= new Packages(this._options));
  }

  private _platformKillswitches?: PlatformKillswitches;
  get platformKillswitches(): PlatformKillswitches {
    return (this._platformKillswitches ??= new PlatformKillswitches(
      this._options,
    ));
  }

  private _platformMcp?: PlatformMcp;
  get platformMcp(): PlatformMcp {
    return (this._platformMcp ??= new PlatformMcp(this._options));
  }

  private _plugins?: Plugins;
  get plugins(): Plugins {
    return (this._plugins ??= new Plugins(this._options));
  }

  private _features?: Features;
  get features(): Features {
    return (this._features ??= new Features(this._options));
  }

  private _projects?: Projects;
  get projects(): Projects {
    return (this._projects ??= new Projects(this._options));
  }

  private _remoteMcp?: RemoteMcp;
  get remoteMcp(): RemoteMcp {
    return (this._remoteMcp ??= new RemoteMcp(this._options));
  }

  private _remoteSessionClients?: RemoteSessionClients;
  get remoteSessionClients(): RemoteSessionClients {
    return (this._remoteSessionClients ??= new RemoteSessionClients(
      this._options,
    ));
  }

  private _remoteSessionIssuers?: RemoteSessionIssuers;
  get remoteSessionIssuers(): RemoteSessionIssuers {
    return (this._remoteSessionIssuers ??= new RemoteSessionIssuers(
      this._options,
    ));
  }

  private _remoteSessions?: RemoteSessions;
  get remoteSessions(): RemoteSessions {
    return (this._remoteSessions ??= new RemoteSessions(this._options));
  }

  private _resources?: Resources;
  get resources(): Resources {
    return (this._resources ??= new Resources(this._options));
  }

  private _risk?: Risk;
  get risk(): Risk {
    return (this._risk ??= new Risk(this._options));
  }

  private _sigint?: Sigint;
  get sigint(): Sigint {
    return (this._sigint ??= new Sigint(this._options));
  }

  private _skillEfficacy?: SkillEfficacy;
  get skillEfficacy(): SkillEfficacy {
    return (this._skillEfficacy ??= new SkillEfficacy(this._options));
  }

  private _skills?: Skills;
  get skills(): Skills {
    return (this._skills ??= new Skills(this._options));
  }

  private _slackDirectoryConnections?: SlackDirectoryConnections;
  get slackDirectoryConnections(): SlackDirectoryConnections {
    return (this._slackDirectoryConnections ??= new SlackDirectoryConnections(
      this._options,
    ));
  }

  private _spendRules?: SpendRules;
  get spendRules(): SpendRules {
    return (this._spendRules ??= new SpendRules(this._options));
  }

  private _telemetry?: Telemetry;
  get telemetry(): Telemetry {
    return (this._telemetry ??= new Telemetry(this._options));
  }

  private _templates?: Templates;
  get templates(): Templates {
    return (this._templates ??= new Templates(this._options));
  }

  private _tokenExchange?: TokenExchange;
  get tokenExchange(): TokenExchange {
    return (this._tokenExchange ??= new TokenExchange(this._options));
  }

  private _tools?: Tools;
  get tools(): Tools {
    return (this._tools ??= new Tools(this._options));
  }

  private _toolsets?: Toolsets;
  get toolsets(): Toolsets {
    return (this._toolsets ??= new Toolsets(this._options));
  }

  private _triggers?: Triggers;
  get triggers(): Triggers {
    return (this._triggers ??= new Triggers(this._options));
  }

  private _tunneledMcp?: TunneledMcp;
  get tunneledMcp(): TunneledMcp {
    return (this._tunneledMcp ??= new TunneledMcp(this._options));
  }

  private _unproxiedMcp?: UnproxiedMcp;
  get unproxiedMcp(): UnproxiedMcp {
    return (this._unproxiedMcp ??= new UnproxiedMcp(this._options));
  }

  private _usage?: Usage;
  get usage(): Usage {
    return (this._usage ??= new Usage(this._options));
  }

  private _userSessionClients?: UserSessionClients;
  get userSessionClients(): UserSessionClients {
    return (this._userSessionClients ??= new UserSessionClients(this._options));
  }

  private _userSessionConsents?: UserSessionConsents;
  get userSessionConsents(): UserSessionConsents {
    return (this._userSessionConsents ??= new UserSessionConsents(
      this._options,
    ));
  }

  private _userSessionIssuers?: UserSessionIssuers;
  get userSessionIssuers(): UserSessionIssuers {
    return (this._userSessionIssuers ??= new UserSessionIssuers(this._options));
  }

  private _userSessionIssuersCimdClients?: UserSessionIssuersCimdClients;
  get userSessionIssuersCimdClients(): UserSessionIssuersCimdClients {
    return (this._userSessionIssuersCimdClients ??=
      new UserSessionIssuersCimdClients(this._options));
  }

  private _userSessions?: UserSessions;
  get userSessions(): UserSessions {
    return (this._userSessions ??= new UserSessions(this._options));
  }

  private _variations?: Variations;
  get variations(): Variations {
    return (this._variations ??= new Variations(this._options));
  }

  private _widgets?: Widgets;
  get widgets(): Widgets {
    return (this._widgets ??= new Widgets(this._options));
  }

  private _workloadIdentities?: WorkloadIdentities;
  get workloadIdentities(): WorkloadIdentities {
    return (this._workloadIdentities ??= new WorkloadIdentities(this._options));
  }

  private _registryDiscovery?: RegistryDiscovery;
  get registryDiscovery(): RegistryDiscovery {
    return (this._registryDiscovery ??= new RegistryDiscovery(this._options));
  }
}
